export class AvProMxNet {
    constructor(socket, log) {
        this.socket = socket;
        this.firmwareVersion = '2.01';
        this.channels = {};
        this.videoOutputs = {}; // output, input
        this.asyncHandlers = [
            {
                name: 'firmwareVersion',
                regExp: /config get version/i,
                callback: (match) => {
                    const resp = {
                        gid: 200000,
                        cmd: match[0],
                        info: this.firmwareVersion,
                        code: 0,
                    };
                    this.socket.send(JSON.stringify(resp));
                },
            },
            {
                name: 'getDeviceList',
                regExp: /config get devicelist/i,
                callback: (match) => {
                    const resp = {
                        gid: 200000,
                        cmd: match[0],
                        info: this.channels,
                        code: 0,
                    };
                    this.socket.send(JSON.stringify(resp));
                },
            },
            {
                name: 'getMatrix',
                regExp: /matrix list\s*(.*)/i,
                callback: (match) => {
                    const resp = {
                        cmd: `matrix list ${match[1]}`,
                        info: {
                            srcs: this.videoOutputs,
                            type: 'va', // video and audio routed together
                        },
                        code: 0,
                    };
                    this.socket.send(JSON.stringify(resp));
                },
            },
            {
                name: 'getName',
                regExp: /config get name/i,
                callback: (match) => {
                    const resp = {
                        gid: 200000,
                        cmd: match[0],
                        info: 'AC-MXNET-CBOX',
                        code: 0,
                    };
                    this.socket.send(JSON.stringify(resp));
                },
            },
            {
                name: 'videoSet',
                regExp: /matrix aset (.+):(.+) (.+) (.+)/i,
                callback: (match) => {
                    this.channels[match[4]].ch_v = this.channels[match[3]].ch;
                    this.channels[match[4]].ch_a = this.channels[match[3]].ch;
                    this.channels[match[4]].ch_u = this.channels[match[3]].ch;
                    this.videoOutputs[match[4]] = match[3];
                    const resp = {
                        gid: 200000,
                        cmd: match[0],
                        info: 'OK',
                        code: 0,
                    };
                    this.socket.send(JSON.stringify(resp));
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`Command incorrect`);
                },
            },
        ];
        this.commandExtractor = {
            terminators: ['\r', '\n'],
        };
        const numberVideoInputs = 16;
        const numberVideoOutputs = 16;
        for (let i = 0; i < numberVideoOutputs; i++) {
            const chanName = `output${i + 1}`;
            this.channels[chanName] = {
                id: chanName,
                ch: '0000',
                ch_v: '0001',
                ch_a: '0001',
                ch_u: '0001',
            };
            this.videoOutputs[chanName] = 'input1';
        }
        for (let i = 0; i < numberVideoInputs; i++) {
            const chanName = `input${i + 1}`;
            this.channels[chanName] = {
                id: chanName,
                ch: (i + 1).toString().padStart(4, '0'),
                is_host: 1,
            };
        }
    }
}
AvProMxNet.emulatorType = 'socketEmulator';
AvProMxNet.key = '-MWUH004tYVU6EnXj9Rs';
